/**
 *  @class
 *  @function VideoSectionMedia
 */
if (!customElements.get('video-section-media')) {
	class VideoSectionMedia extends HTMLElement {
		connectedCallback() {
			// Lazysizes only swaps data-src to src for img/picture/source, so
			// iframes (YouTube/Vimeo) are lazy-loaded here instead: load the
			// real src once the element scrolls into view.
			const iframe = this.querySelector('iframe');
			if (!iframe || !iframe.dataset.src) return;

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						observer.disconnect();
						iframe.src = iframe.dataset.src;
						iframe.removeAttribute('data-src');
					}
				});
			}, { rootMargin: '250px' });
			observer.observe(this);
		}
	}
	customElements.define('video-section-media', VideoSectionMedia);
}
